import { render, staticRenderFns } from "./GridCronograma.vue?vue&type=template&id=b4d84504&"
import script from "./GridCronograma.vue?vue&type=script&lang=js&"
export * from "./GridCronograma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports